export default {
  title: "Profilo",
  description: "Gestisci il tuo profilo personale",
  personalInfo: "Informazioni personali",
  weddingInfo: "Informazioni sul matrimonio",
  form: {
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    weddingDate: "Data del matrimonio",
    partnerName: "Nome del partner",
    venue: "Luogo",
    location: "Posizione",
    about: "Chi sono",
    save: "Salva modifiche"
  },
  actions: {
    save: "Salva",
    cancel: "Annulla",
    edit: "Modifica"
  },
  messages: {
    profileUpdated: "Profilo aggiornato con successo",
    error: "Si è verificato un errore",
    updateSuccess: "Profilo aggiornato con successo",
    updateError: "Errore durante l'aggiornamento del profilo",
    photoUploadSuccess: "Foto caricata con successo",
    photoUploadError: "Errore durante il caricamento della foto"
  },
  photo: {
    alt: "Foto profilo",
    upload: "Carica una foto",
    change: "Cambia foto",
    remove: "Elimina foto"
  }
};
